export const fontImports = [
    {
        family: 'GoogleSans',
        folder: 'delonghi',
        variants: [
            {
                name: 'Regular',
                weight: 400,
            },
            {
                name: 'Medium',
                weight: 500,
            },
            {
                name: 'SemiBold',
                weight: 600,
            },
            {
                name: 'Bold',
                weight: 700,
            },
        ],
    },
    {
        family: 'DeLonghiSerif',
        folder: 'delonghi',
        variants: [
            {
                name: 'Light',
                weight: 300,
            },
            {
                name: 'Regular',
                weight: 400,
            },
            {
                name: 'Medium',
                weight: 500,
            },
        ],
    },
    {
        family: 'NotoSans',
        folder: 'global',
        variants: [
            {
                name: 'Regular',
                weight: 400,
            },
            {
                name: 'Bold',
                weight: 700,
            },
        ],
    },
]
